import { EpimsBaseEntityDto } from './epim-base.dto';
export class HierarchyDto extends EpimsBaseEntityDto {

    HierarchyName: string;
    Abbreviation: string;
    Description: string;
    SubscriptionUserId: string;
    Version: number;
}